"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useListboxContextValues", {
    enumerable: true,
    get: function() {
        return useListboxContextValues;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const _ComboboxContext = require("./ComboboxContext");
function useListboxContextValues(state) {
    const hasComboboxContext = (0, _reactcontextselector.useHasParentContext)(_ComboboxContext.ComboboxContext);
    const { activeOption, focusVisible, multiselect, registerOption, selectedOptions, selectOption, setActiveOption } = state;
    // get register/unregister functions from parent combobox context
    const comboboxRegisterOption = (0, _reactcontextselector.useContextSelector)(_ComboboxContext.ComboboxContext, (ctx)=>ctx.registerOption);
    const registerOptionValue = hasComboboxContext ? comboboxRegisterOption : registerOption;
    const listbox = {
        activeOption,
        focusVisible,
        multiselect,
        registerOption: registerOptionValue,
        selectedOptions,
        selectOption,
        setActiveOption
    };
    return {
        listbox
    };
}
